import { createApi } from 'ReduxHelpers';
import { getBackRoyalApiBaseConfig } from 'BackRoyalApi';
import { type BaseQueryApi } from '@reduxjs/toolkit/query';
import { uploadFiles, type ImageUploadResponse, type QueryFnBaseQuery, type S3Asset } from 'ContentItemEditor';

const baseConfig = getBackRoyalApiBaseConfig('globalMetadataApi', { convertCasing: false });

export const globalMetadataApi = createApi('globalMetadataApi', {
    ...baseConfig,
    endpoints: builder => ({
        // Writes the file to S3 only. The record gets the image when the form saves.
        uploadGlobalMetadataImages: builder.mutation<S3Asset[], { globalMetadataId: string; files: File[] }>({
            async queryFn(
                { globalMetadataId, files },
                _api: BaseQueryApi,
                _options,
                fetchWithBaseQuery: QueryFnBaseQuery,
            ) {
                const result = await uploadFiles<ImageUploadResponse>(
                    { url: `global_metadata/${globalMetadataId}/images.json`, key: 'images[]', files },
                    fetchWithBaseQuery,
                );
                if (result.error) return { error: result.error };
                return { data: result.data.contents.images };
            },
            extraOptions: { maxRetries: 0 },
        }),
    }),
});
